import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "./helper";

export const reportActionSlice = createApi({
  baseQuery,
  reducerPath: "reportApi",
  tagTypes: ["ReportList"],
  endpoints: (build) => ({
    getReportList: build.query<ReportListResponseDto, ReportListRequestDto>({
      query: ({ numberOfEntitiesPerPage, pageNo, isPreProd }) => {
        return {
          url: `/v1/reports/paginated`,
          params: {
            pageNo,
            numberOfEntitiesPerPage,
            ...(isPreProd && { isPreProd }),
          },
          method: "GET",
        };
      },
      providesTags: ["ReportList"],
    }),
    getReportsPaginationCount: build.query<
      ReportsPaginationCountResponseDto,
      ReportsPaginationCountRequestDto
    >({
      query: ({ isPreProd }) => {
        return {
          url: `/v1/reports/pagination-count`,
          params: {
            ...(isPreProd && { isPreProd }),
          },
          method: "GET",
        };
      },
    }),
    downloadReportByReportId: build.query<
      string,
      DownloadReportByReportIdRequestDto
    >({
      query: ({ reportId, isPreProd }) => {
        return {
          url: `/v1/reports/${reportId}/download-url`,
          params: {
            ...(isPreProd && { isPreProd }),
          },
          method: "GET",
          responseHandler: (response: Response) => response.text(),
        };
      },
    }),
    generateReport: build.mutation<void, GenerateReportRequestDto>({
      query: (body) => {
        return {
          url: `/v1/reports`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ReportList"],
    }),
    getReportTypes: build.query<ReportTypeResponseDto, void>({
      query: () => {
        return {
          url: `/v1/reports/types`,
          method: "GET",
        };
      },
    }),
  }),
});

export interface ReportDetail {
  _id: string;
  lenderId: string;
  reportType: keyof typeof ReportType;
  fromDate: string;
  toDate: string;
  status: ReportStatus;
  createdAt: string;
}

export type ReportTypeResponseDto = ReportType[];

export type ReportStatus = "RUNNING" | "PENDING" | "FAILED" | "SUCCEEDED";

export enum ReportType {
  DISBURSAL_REPORT = "DISBURSAL_REPORT",
  MASTER_LOAN_REPORT_V2 = "MASTER_LOAN_REPORT_V2",
  REVENUE_REPORT = "REVENUE_REPORT",
  REVENUE_REPORT_PI_COLLECTION = "REVENUE_REPORT_PI_COLLECTION",
  BUREAU_REPORT = "BUREAU_REPORT",
  MASTER_BORROWER_REPORT = "MASTER_BORROWER_REPORT",
  COLLECTION_REPORT = "COLLECTION_REPORT",
}

export type ReportListResponseDto = ReportDetail[];
export type ReportListRequestDto = {
  pageNo: number;
  numberOfEntitiesPerPage: number;
  isPreProd?: boolean;
};

export type ReportsPaginationCountResponseDto = {
  totalCount: number;
};

export type ReportsPaginationCountRequestDto = {
  isPreProd?: boolean;
};

export type DownloadReportByReportIdRequestDto = {
  reportId: string;
  isPreProd?: boolean;
};

type GenerateReport = {
  reportType: ReportType;
  fromDate: string;
  toDate: string;
  isPreProd?: boolean;
};
export type GenerateReportRequestDto = GenerateReport;

export const {
  useGetReportListQuery,
  useDownloadReportByReportIdQuery,
  useGetReportsPaginationCountQuery,
  useGenerateReportMutation,
  useLazyDownloadReportByReportIdQuery,
  useGetReportTypesQuery,
} = reportActionSlice;
